import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '../PendingsCard';
import PortalsNotificatonsContainer from './PortalsNotificatonsContainer';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPortalsNotifications } from '@/store/slices/components/dashboard/service';
import PortalsNotificationsEmptyState from './PortalsNotificationsEmptyState';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function PortalsNotifications() {
  const dispatch = useDispatch();
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const track = useTrackPendingTab();
  const {
    loading,
    hasFetched,
    total_errors,
    total_alerts,
    portals,
    properties,
    empty,
  } = useSelector((state) => state.DashboardSlice.portalsNotifications);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const urlRedirect = `${tokkoHost}/portals/portals/`;

  useFetchOnViewport(
    (query) => {
      dispatch(getPortalsNotifications(query));
    },
    [],
    { hasFetched }
  );

  const { allPermissions } = useSelector(
    (state) => state.AuthSlice.permissions
  );

  const alertText = `${total_alerts} ${Trans(
    translations,
    total_alerts === 1
      ? 'DahsboardPendings.ListingAlert'
      : 'DahsboardPendings.ListingsAlerts'
  )}`;
  const errorText = `${total_errors} ${Trans(
    translations,
    total_errors === 1 ? 'DahsboardPendings.Error' : 'DahsboardPendings.Errors'
  )}`;
  const notificationTitle = `${alertText} ${Trans(
    translations,
    'DahsboardPendings.&'
  )} ${errorText}`;

  const canSeeReservationList = allPermissions.includes(
    'can_see_reservation_list'
  );

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={canSeeReservationList && !empty ? urlRedirect : false}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.portalsNotifications(element)}
      >
        {notificationTitle}
      </PendingCard.Header>
      {empty ? (
        <PortalsNotificationsEmptyState />
      ) : (
        <PortalsNotificatonsContainer
          portals={portals}
          properties={properties}
          trackCallback={(element) => track.portalsNotifications(element)}
        />
      )}
    </PendingCard>
  );
}

export default PortalsNotifications;
